import { createGlobalStyle } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../theme';
import { withTriangle } from './mixins';

const GoogleMapsStyles = createGlobalStyle(({ theme }) => {
  const bg = ThemeColors.COLOR_ORANGE2;
  const border = theme.colorWhite;
  const boxShadow = `0 2px 6px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH3, 0.65)}`;

  return {
    '.gm-style': {
      '.gm-style-iw-t': {
        borderWidth: 0,
        ...withTriangle({
          width: 12,
          height: 7,
          direction: 'down',
          borderColor: border,
          backgroundColor: bg,
          position: {
            left: 0,
            top: '100%',
            transform: 'translate(-50%, -1px)',
          },
          dropShadow: `drop-shadow(${boxShadow})`,
          afterOverrides: {
            background: 'initial',
            boxShadow: 'none',
          },
          applyOwnStyles: false,
        }),
      },
      '.gm-style-iw-tc, .gm-style-iw-chr': {
        display: 'none',
      },
      '.gm-style-iw-c': {
        borderRadius: theme.borderRadius,
        fontFamily: ThemeFont.FONT_FAMILY5,
        fontWeight: 'bold',
        lineHeight: '22px',
        padding: `${ThemeSpaces.SPACE_NORM0_5}px ${ThemeSpaces.SPACE_NORM}px !important`,
        border: `1px solid ${border}`,
        boxShadow,
        backgroundColor: bg,
        color: theme.colorWhite,
        fontSize: theme.fontSize,
        '> button': {
          display: 'none !important',
          '> img': {
            display: 'none !important',
          },
        },
      },
      '.gm-style-iw-d': {
        overflow: 'hidden !important',
      },
    },

    // Marker label className set via the Google Maps SDK config (see
    // QuoteDetailMap.jsx's originMarker/destinationMarker) — the SDK
    // creates this DOM node outside React's tree.
    '.quote-plane-direction-left': {
      transform: 'rotateY(-180deg)',
    },
  };
});

export default GoogleMapsStyles;
